import React from 'react';
import { useForm, Controller } from 'react-hook-form';

import { Grid, GridCol, Select, SelectOption } from '@flixbus/honeycomb-react';

import DaterangeFilter from 'common/DaterangeFilter';

import { ALL_REASONS_OPTION_VALUE, UNAVAILABILITY_FILTER_TEXT } from './text';

const EMPTY_VALUES = {
	dateRange: '',
	reason: ALL_REASONS_OPTION_VALUE,
};

const UnavailabilityFilter = ({ onFiltersSubmited, reasons, loading }) => {
	const { control, resetField, getValues } = useForm({
		mode: 'onChange',
		defaultValues: EMPTY_VALUES,
	});

	const onSubmit = (data) => {
		onFiltersSubmited(data);
	};

	const submitOnClearingField = () => {
		const data = getValues();
		onSubmit(data);
	};

	const handleResetSingleField = (fieldname) => {
		resetField(fieldname);
		submitOnClearingField();
	};

	const submitOnChange = () => {
		const data = getValues();
		onSubmit(data);
	};
	return (
		<form>
			<Grid>
				<GridCol size={5}>
					<Controller
						name="dateRange"
						control={control}
						render={({ field }) => (
							<DaterangeFilter
								onReset={() => handleResetSingleField('dateRange')}
								fieldControl={field}
								label=""
								id="unavailabillity-daterange"
								doSubmitOnChange={true}
								onSubmitOnChange={submitOnChange}
							/>
						)}
					/>
				</GridCol>
				<GridCol size={4}>
					<Controller
						name="reason"
						control={control}
						render={({ field }) => (
							<Select
								aria-label={UNAVAILABILITY_FILTER_TEXT.reasonSelectAriaLabel}
								id="filterByReasonsID"
								name="reason"
								defaultValue={ALL_REASONS_OPTION_VALUE}
								disabled={loading}
								onChange={(e) => {
									field.onChange(e.target.value);
									submitOnChange();
								}}
							>
								<SelectOption value={ALL_REASONS_OPTION_VALUE}>
									{UNAVAILABILITY_FILTER_TEXT.allReasonsOption}
								</SelectOption>
								{reasons !== undefined &&
									reasons.map((reason) => (
										<SelectOption key={reason.id} value={reason.id}>
											{reason.isPayable ? `$ ${reason.name}` : reason.name}
										</SelectOption>
									))}
							</Select>
						)}
					/>
				</GridCol>
			</Grid>
		</form>
	);
};

export default UnavailabilityFilter;
